export default "/images/vendor/flag-icon-css/flags/1x1/km.svg?4c4fa2a75b7c9360ac5f343b19ad4c9e";